export function extractLettersAndWhitespace(input: string): string {
    // Use a regular expression to match letters (both uppercase and lowercase) and whitespace
    const lettersAndWhitespaceRegex = /[a-zA-Z\s]/g;
    
    // Use the match method to find all occurrences of letters and whitespace
    const matches = input.match(lettersAndWhitespaceRegex);
    
    // If matches are found, join them into a string; otherwise, return an empty string
    return matches ? matches.join('') : '';
}